<template>
  <div class="people-describe-editor">
    <el-form ref="form" label-width="100px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="currentItem.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="图片">
        <div class="image">
          <div class="add-btn" v-if="!currentItem.image" @click="selectThumb">+</div>
          <img v-if="currentItem.image" title="点击更换" :src="currentItem.image" @click="selectThumb"/>
        </div>
      </el-form-item>
      <el-form-item label="描述">
        <el-input type="textarea" :autosize="{minRows:3}" v-model="currentItem.text" placeholder="请输入内容"></el-input>
      </el-form-item>
    </el-form>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import UploadImg from '@/components/UploadImg'
export default {
  name: 'peopleDescribeEditor',
  components: {
    UploadImg
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  methods: {
    selectThumb () {
      let list = []
      if (this.currentItem.image) {
        list = [this.currentItem.image]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.currentItem.image = res[0]
        }
      }).catch()
    }
  }
}
</script>
<style lang="less" scoped>
.people-describe-editor {
  .image {
    .add-btn {
      cursor: pointer;
      text-align: center;
      line-height: 50px;
      width: 50px;
      height: 50px;
      border: 1px dashed #cccccc;
    }
    img {
      cursor: pointer;
      height: 50px;
      width: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/peopleDescribeEditor.vue